import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import AdminSidebar from "./AdminSidebar";
import AdminMobileHeader from "./AdminMobileHeader";
import AdminMobileDrawer from "./AdminMobileDrawer";

const AdminLayout = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  return (
    <div className="relative flex h-screen w-full overflow-hidden bg-slate-100">
      {/* Mobile Header */}
      <AdminMobileHeader onMenuClick={() => setIsDrawerOpen(true)} />

      {/* Mobile Drawer */}
      <AdminMobileDrawer
        isOpen={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
      />

      {/* Desktop Sidebar */}
      <AdminSidebar />

      {/* Main Content */}
      <main className="flex-1 p-[5%] sm:p-6 md:p-8 overflow-y-auto @container">
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;
